import { jsx as n } from "react/jsx-runtime";
import { u as y } from "./index-6a632112.mjs";
import { c as $, C as p, a as u } from "./createOptions-4792754a.mjs";
import "react";
import "./themes-5f0b3c3d.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./lineHeights-72d3110c.mjs";
const b = ({
  chartLibElement: s,
  xAxis: c,
  yAxis: m,
  series: r,
  labelFormatter: d,
  legend: i,
  gridType: h = "both",
  hideTooltip: S,
  height: a,
  width: l
}) => {
  const t = $({
    type: p.SCATTER,
    xAxis: c,
    yAxis: m,
    series: r,
    labelFormatter: d,
    legend: i,
    isCategorical: !0,
    gridType: h,
    hideLabel: !0,
    hideTooltip: S
  }), e = u({ type: p.SCATTER }), g = y.div`
    ${e.tooltipStyles};
    ${e.gridStyles};
    ${(o) => e?.legendStyles(
    t?.legend?.horizontalAlign,
    t?.legend?.orientation,
    t?.legend?.position,
    o.$vertical
  )}
    ${e?.legendStyles((o) => o.$vertical)};
    height: 100%;
    width: 100%;
    min-height: 350px;
    overflow-x: auto;
  `;
  return /* @__PURE__ */ n(
    g,
    {
      "data-testid": "scatterPlot-wrapper",
      $vertical: i?.orientation === "vertical",
      children: /* @__PURE__ */ n(
        s,
        {
          type: "scatter",
          width: l ? `${l}px` : "100%",
          options: t,
          series: r,
          height: a || "100%"
        }
      )
    }
  );
};
export {
  b as ScatterPlotChart
};
